import { REFRESH_AUTH_TOKEN, START_INTERVAL, RUNNING_INTERVAL, STOP_INTERVAL } from "../actions/refresh_token";

export interface IRefreshTokenReducer {
  expiredToken: Date;
  expiredLogout: Date;
  isRunning: boolean;
}

const initialState: IRefreshTokenReducer = {
  expiredToken: null,
  expiredLogout: null,
  isRunning: false
};

export default (state = initialState, action: any) => {
  switch (action.type) {
    case START_INTERVAL:
      return {
        ...state,
        isRunning: true
      };
    case REFRESH_AUTH_TOKEN:
    case RUNNING_INTERVAL:
      return {
        ...state,
        expiredToken: action.payload.expiredToken,
        expiredLogout: action.payload.expiredLogout,
      };
    case STOP_INTERVAL:
      return {
        ...state,
        isRunning: false
      };
    default:
      return state;
  }
};
